import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import {
  addUniversity,
  deleteUniversity,
  getCities,
  getCountries,
  getDistricts,
  getStates,
  getUniversities,
  updateCity,
  updateUniversity,
} from "../../Services/HomeService";
import toast from "react-hot-toast";
import Swal from "sweetalert2";

const ManageUniversity = () => {
  const [states, setStates] = useState([]);
  const [fetchStatesLoading, setFetchStatesLoading] = useState(false);
  const [districts, setDistricts] = useState([]);
  const [fetchDistrictsLoading, setFetchDistrictsLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [fetchCitiesLoading, setFetchCitiesLoading] = useState(false);
  const [universities, setUniversities] = useState([]);
  const [fetchUniversitiesLoading, setFetchUniversitiesLoading] =
    useState(false);

  const [createUniversityObject, setCreateUniversityObject] = useState({});
  const [createUniversityLoading, setCreateUniversityLoading] = useState(false);

  const [updateUniversityLoading, setupdateUniversityLoading] = useState(false);

  const [editUniversity, setEditUniversity] = useState(null);

  const [countries, setCountries] = useState([]);
  const [fetchCountriesLoading, setFetchCountriesLoading] = useState(false);

  const fetchCountries = async () => {
    try {
      setFetchCountriesLoading(true);
      const res = await getCountries();
      console.log("fetched counries", res);
      if (res?.status) {
        setCountries(res?.data);
        setFetchCountriesLoading(false);
      } else {
        toast.error("Error while Fetching Counries Data");
        setFetchCountriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Counries Data");
      console.error("Error fetching Counries:", error);
      setFetchCountriesLoading(false);
    }
  };

  const fetchCities = async () => {
    try {
      setFetchCitiesLoading(true);
      const res = await getCities();
      console.log("fetched Cities", res?.data);
      if (res?.status) {
        setCities(res?.data);
        setFetchCitiesLoading(false);
      } else {
        toast.error("Error while Fetching Cities Data");
        setFetchCitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Cities Data");
      console.error("Error fetching Districts:", error);
      setFetchCitiesLoading(false);
    }
  };

  const fetchDistricts = async () => {
    try {
      setFetchDistrictsLoading(true);
      const res = await getDistricts();
      console.log("fetched districts", res?.data);
      if (res?.status) {
        setDistricts(res?.data);
        setFetchDistrictsLoading(false);
      } else {
        toast.error("Error while Fetching Districts Data");
        setFetchDistrictsLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Districts Data");
      console.error("Error fetching Districts:", error);
      setFetchDistrictsLoading(false);
    }
  };

  const fetchStates = async (country) => {
    try {
      setFetchStatesLoading(true);
      const res = await getStates();
      console.log("fetched states", res);
      if (res?.status) {
        setStates(res?.data.filter((item) => item.country._id === country));
        setFetchStatesLoading(false);
      } else {
        toast.error("Error while Fetching States Data");
        setFetchStatesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch States Data");
      console.error("Error fetching State:", error);
      setFetchStatesLoading(false);
    }
  };

  const fetchUniversities = async () => {
    try {
      setFetchUniversitiesLoading(true);
      const res = await getUniversities();
      console.log("fetched Universities", res);
      if (res?.status) {
        setUniversities(res?.data);
        setFetchUniversitiesLoading(false);
      } else {
        toast.error("Error while Fetching Universities Data");
        setFetchUniversitiesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Universities Data");
      console.error("Error fetching Universities:", error);
      setFetchUniversitiesLoading(false);
    }
  };

  useEffect(() => {
    fetchCountries();
    fetchStates();
    fetchDistricts();
    fetchCities();
    fetchUniversities();
  }, []);

  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };
  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        color: "#333",
      },
    },
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      center: true,
    },
    {
      name: "Country",
      selector: (row) => row.country?.countryName,
      sortable: true,
      center: true,
    },
    {
      name: "State",
      selector: (row) => row?.state?.stateName,
      sortable: true,
      center: true,
    },
    {
      name: "District",
      selector: (row) => row?.district?.districtName,
      sortable: true,
      center: true,
    },
    {
      name: "City",
      selector: (row) => row?.city?.cityName,
      sortable: true,
      center: true,
    },
    {
      name: "University",
      selector: (row) => row.name,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              onClick={() => {
                handleUpdateClick(row);
              }}
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          {/* <span title="Delete">
            <i
              onClick={() => {
                handleDelete(row?._id);
              }}
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span> */}
        </>
      ),
    },
  ];

  const handleCreateUniversity = async (e) => {
    e?.preventDefault();
    if (
      !createUniversityObject?.districtId ||
      !createUniversityObject?.stateId ||
      !createUniversityObject?.cityId ||
      !createUniversityObject?.name
    ) {
      toast.error("Please Enter All Fields");
      return;
    }
    try {
      setCreateUniversityLoading(true);
      const res = await addUniversity(createUniversityObject);
      console.log("University Add Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setCreateUniversityObject((prev) => ({ ...prev, name: "" }));
        fetchUniversities();
        setCreateUniversityLoading(false);
      } else {
        toast.error(res?.message);
        setCreateUniversityLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add University.");
      console.error("Error adding University:", error);
      setCreateUniversityLoading(false);
    }
  };

  const handleUpdateClick = (row) => {
    setEditUniversity(row);
    fetchStates(row?.country._id);
  };

  const handleCancel = () => {
    setEditUniversity(null);
  };

  const handleUpdateUniversity = async (e) => {
    e?.preventDefault();
    if (
      !editUniversity?.name ||
      !editUniversity?.state?._id ||
      !editUniversity?.district?._id ||
      !editUniversity?.city?._id
    ) {
      return toast.error("Enter All Fields to Update");
    }

    try {
      setupdateUniversityLoading(true);
      const res = await updateUniversity(editUniversity?._id, {
        stateId: editUniversity?.state?._id,
        districtId: editUniversity?.district?._id,
        name: editUniversity?.name,
        cityId: editUniversity?.city?._id,
      });
      console.log("University update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setEditUniversity(null);
        fetchUniversities();
        setupdateUniversityLoading(false);
      } else {
        toast.error(res?.message);
        setupdateUniversityLoading(false);
      }
    } catch (error) {
      toast.error("Failed to Update University.");
      console.error("Error Updating University:", error);
      setupdateUniversityLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete University?",
      text: "Are you sure you want to delete this university?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteUniversity(id);
        Swal.fire("Deleted!", "university has been deleted.", "success");
        fetchUniversities();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete university.", "error");
      }
    }
  };

  let a = false;
  let b = false;
  let c = false;
  let d = false;

  useEffect(() => {
    fetchStates(createUniversityObject?.countryId);
  }, [createUniversityObject?.countryId]);

  return (
    <>
      {!editUniversity && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Manage University
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleCreateUniversity(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-4 mt-3">
                    <label htmlFor="name">
                      Country<span className="text-danger">*</span>
                    </label>
                    <select
                      required
                      className="form-control"
                      onChange={(e) => {
                        setCreateUniversityObject((prev) => ({
                          ...prev,
                          countryId: e?.target?.value,
                        }));
                      }}
                      value={createUniversityObject?.countryId}
                    >
                      <option value="">-------- Select Country --------</option>
                      {fetchCountriesLoading ? (
                        <option>Loading...</option>
                      ) : countries?.length === 0 ? (
                        <option disabled>No Country Found</option>
                      ) : (
                        countries?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.countryName}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>
                  <div className="col-md-4 mt-3">
                    <label htmlFor="name">
                      State Name<span className="text-danger">*</span>
                    </label>
                    <select
                      required
                      className="form-control"
                      onChange={(e) => {
                        setCreateUniversityObject((prev) => ({
                          ...prev,
                          stateId: e?.target?.value,
                        }));
                      }}
                      value={createUniversityObject?.stateId}
                    >
                      <option value="">-------- Select State --------</option>
                      {fetchStatesLoading ? (
                        <option>Loading...</option>
                      ) : states?.length === 0 ? (
                        <option disabled>No State Found</option>
                      ) : (
                        states?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.stateName}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>
                  <div className="col-md-4 mt-3">
                    <label htmlFor="name">
                      District Name<span className="text-danger">*</span>
                    </label>
                    <select
                      required
                      disabled={!createUniversityObject?.stateId}
                      className="form-control"
                      onChange={(e) => {
                        setCreateUniversityObject((prev) => ({
                          ...prev,
                          districtId: e?.target?.value,
                        }));
                      }}
                    >
                      <option value="">
                        -------- Select District --------
                      </option>
                      {fetchDistrictsLoading ? (
                        <option>Loading...</option>
                      ) : districts?.length === 0 ? (
                        <option disabled>No District Found</option>
                      ) : (
                        districts?.map((e, i) => {
                          if (
                            e?.state?._id === createUniversityObject?.stateId
                          ) {
                            a = true;
                            return (
                              <option key={i} value={e?._id}>
                                {e?.districtName}
                              </option>
                            );
                          }
                        })
                      )}
                      {!a && <option disabled>No District found</option>}
                      {/* <option value="">North 24 Parganas</option>
                    <option value="">Kolkata</option>
                    <option value="">Siliguri</option>
                    <option value="">Purulia</option> */}
                    </select>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      City Name<span className="text-danger">*</span>
                    </label>
                    <select
                      required
                      disabled={!createUniversityObject?.districtId}
                      className="form-control"
                      onChange={(e) => {
                        setCreateUniversityObject((prev) => ({
                          ...prev,
                          cityId: e?.target?.value,
                        }));
                      }}
                    >
                      <option value="">-------- Select City --------</option>
                      {fetchCitiesLoading ? (
                        <option>Loading...</option>
                      ) : cities?.length === 0 ? (
                        <option disabled>No City Found</option>
                      ) : (
                        cities?.map((e, i) => {
                          if (
                            e?.district?._id ===
                            createUniversityObject?.districtId
                          ) {
                            b = true;
                            return (
                              <option key={i} value={e?._id}>
                                {e?.cityName}
                              </option>
                            );
                          }
                        })
                      )}
                      {!b && <option disabled>No City Found</option>}
                    </select>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      University Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      value={createUniversityObject?.name}
                      onChange={(e) =>
                        setCreateUniversityObject((prev) => ({
                          ...prev,
                          name: e?.target?.value,
                        }))
                      }
                      placeholder="Enter University Name"
                      required
                    />
                  </div>
                </div>
                <div className=" d-flex justify-content-center">
                  <button
                    disabled={createUniversityLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {createUniversityLoading ? "Loading..." : "Add University"}
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
      {!editUniversity && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <section className="chartBox_area">
              <DataTable
                data={universities}
                columns={columns}
                pagination
                responsive
                highlightOnHover
                customStyles={customStyles}
                progressPending={fetchUniversitiesLoading}
              />
            </section>
          </div>
        </div>
      )}

      {editUniversity && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Update University
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleUpdateUniversity(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-4 mt-3">
                    <label htmlFor="name">
                      Country<span className="text-danger">*</span>
                    </label>
                    <select
                      required
                      className="form-control"
                      onChange={(e) => {
                        setEditUniversity((prev) => ({
                          ...prev,
                          country: { ...prev?.country, _id: e?.target?.value },
                          state: { ...prev?.state, _id: e?.target?.value },
                          city: { ...prev?.city, _id: "" },
                          district: { ...prev?.district, _id: "" },
                        }));
                      }}
                      value={editUniversity?.country?._id}
                    >
                      <option value="">-------- Select Country --------</option>
                      {fetchCountriesLoading ? (
                        <option>Loading...</option>
                      ) : countries?.length === 0 ? (
                        <option disabled>No Country Found</option>
                      ) : (
                        countries?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.countryName}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>
                  <div className="col-md-4 mt-3">
                    <label htmlFor="name">
                      State Name<span className="text-danger">*</span>
                    </label>
                    <select
                      value={editUniversity?.state?._id}
                      required
                      className="form-control"
                      onChange={(e) => {
                        setEditUniversity((prev) => ({
                          ...prev,
                          state: { ...prev?.state, _id: e?.target?.value },
                          city: { ...prev?.city, _id: "" },
                          district: { ...prev?.district, _id: "" },
                        }));
                      }}
                    >
                      <option value="">-------- Select State --------</option>
                      {fetchStatesLoading ? (
                        <option>Loading...</option>
                      ) : states?.length === 0 ? (
                        <option disabled>No State Found</option>
                      ) : (
                        states?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.stateName}
                            </option>
                          );
                        })
                      )}

                      {/* <option value="">Orisa</option>
                    <option value="">Delhi</option>
                    <option value="">Bihar</option> */}
                    </select>
                  </div>
                  <div className="col-md-4 mt-3">
                    <label htmlFor="name">
                      District Name<span className="text-danger">*</span>
                    </label>
                    <select
                      value={editUniversity?.district?._id}
                      required
                      disabled={!editUniversity?.state?._id}
                      className="form-control"
                      onChange={(e) => {
                        setEditUniversity((prev) => ({
                          ...prev,
                          district: {
                            ...prev?.district,
                            _id: e?.target?.value,
                          },
                        }));
                      }}
                    >
                      <option value="">
                        -------- Select District --------
                      </option>
                      {fetchDistrictsLoading ? (
                        <option>Loading...</option>
                      ) : districts?.length === 0 ? (
                        <option disabled>No District Found</option>
                      ) : (
                        districts?.map((e, i) => {
                          if (e?.state?._id === editUniversity?.state?._id) {
                            c = true;
                            return (
                              <option key={i} value={e?._id}>
                                {e?.districtName}
                              </option>
                            );
                          }
                        })
                      )}
                      {!c && <option disabled>No District found</option>}
                      {/* <option value="">North 24 Parganas</option>
                    <option value="">Kolkata</option>
                    <option value="">Siliguri</option>
                    <option value="">Purulia</option> */}
                    </select>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      City Name<span className="text-danger">*</span>
                    </label>
                    <select
                      value={editUniversity?.city?._id}
                      required
                      disabled={!editUniversity?.district?._id}
                      className="form-control"
                      onChange={(e) => {
                        setEditUniversity((prev) => ({
                          ...prev,
                          city: { ...prev?.city, _id: e?.target?.value },
                        }));
                      }}
                    >
                      <option value="">-------- Select City --------</option>
                      {fetchCitiesLoading ? (
                        <option>Loading...</option>
                      ) : cities?.length === 0 ? (
                        <option disabled>No City Found</option>
                      ) : (
                        cities?.map((e, i) => {
                          if (
                            e?.district?._id === editUniversity?.district?._id
                          ) {
                            d = true;
                            return (
                              <option key={i} value={e?._id}>
                                {e?.cityName}
                              </option>
                            );
                          }
                        })
                      )}
                      {!d && <option disabled>No City Found</option>}
                    </select>
                  </div>
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      University Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      className="form-control"
                      value={editUniversity?.name}
                      onChange={(e) =>
                        setEditUniversity((prev) => ({
                          ...prev,
                          name: e?.target?.value,
                        }))
                      }
                      placeholder="Enter University Name"
                      required
                    />
                  </div>
                </div>
                <div
                  className=" d-flex justify-content-center"
                  style={{ gap: "15px" }}
                >
                  <button
                    disabled={updateUniversityLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {updateUniversityLoading
                      ? "Loading..."
                      : "Update University"}
                  </button>
                  <button
                    onClick={() => {
                      handleCancel();
                    }}
                    disabled={updateUniversityLoading}
                    type="button"
                    className="btn mt-3"
                    style={{
                      background: "#f77754",
                      borderRadius: "13px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default ManageUniversity;
